import { useSelector } from 'react-redux'

import {
  selectResourceFilterData,
  selectResourceFilterOptions,
  selectResourceFilterOptionsMap,
  selectResourceFilterStatus
} from 'redux/selectors/ResourceFilter'

export const useResourceFilterOptions = () =>
  useSelector(selectResourceFilterOptions)

export const useResourceFilterOptionsMap = () =>
  useSelector(selectResourceFilterOptionsMap)

export const useResourceFilterData = () => useSelector(selectResourceFilterData)

export const useResourceFilterStatus = () =>
  useSelector(selectResourceFilterStatus)
